"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _connectedReactRouter = require("connected-react-router");

var _Link = _interopRequireDefault(require("./Link"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // eslint-disable-next-line react/prop-types


var ConnectedLinkInner = function ConnectedLinkInner(_ref, ref) {
  var to = _ref.to,
      otherProps = _objectWithoutProperties(_ref, ["to"]);

  var dispatch = (0, _reactRedux.useDispatch)();

  var onClick = function onClick(to) {
    return function (e) {
      e.preventDefault();
      dispatch((0, _connectedReactRouter.push)(to));
    };
  };

  return _react.default.createElement(_Link.default, _extends({
    ref: ref,
    to: to,
    onClick: onClick(to)
  }, otherProps));
};

var ConnectedLink = _react.default.forwardRef(ConnectedLinkInner);

ConnectedLink.propTypes = {
  label: _propTypes.default.string,
  children: _propTypes.default.node,
  to: _propTypes.default.string.isRequired
};
var _default = ConnectedLink;
exports.default = _default;